export default{
	token:(state)=> {
    return state.token;
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js